import { Component } from 'react'
import PropTypes from 'prop-types'
import PlayerApi from '../../utils/playerApi'
import DataApi from '../../utils/dataApi'

export default class PlayerApiFetch extends Component {
  state = {
    results: {},
    fetchFail: false,
    fetchSuccess: false,
  }

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      const api = this.props.api === 'data' ? DataApi() : PlayerApi()
      const { results, data, meta } = await api({ ...this.props.params, sendAuthHeader: true })
      const recoID = meta?.analytics?.personalisationRequestID
      const metaData = data && data.map(x => ({ ...x, recoID }))
      const success = Boolean(results) || Boolean(data) // results should be undefined on a 404 etc

      this.setState({
        results: results || metaData,
        fetchSuccess: success,
        fetchFail: !success,
      })
    } catch (e) {
      // this is only reached when the fetch fails entirely
      // 4xx or 5xx errors are counted as successful.
      this.setState({
        fetchFail: true,
        fetchSuccess: false,
      })
    }
  }

  render() {
    if (this.state.fetchSuccess) {
      return this.props.success(this.state.results)
    }

    if (this.state.fetchFail) {
      return this.props.fail()
    }

    return this.props.fetching()
  }
}

PlayerApiFetch.propTypes = {
  params: PropTypes.shape({
    path: PropTypes.string,
    query: PropTypes.shape({}),
  }),
  fetching: PropTypes.func,
  success: PropTypes.func,
  fail: PropTypes.func,
  api: PropTypes.string,
}

PlayerApiFetch.defaultProps = {
  params: {},
  fetching: () => null,
  success: () => null,
  fail: () => null,
  api: '',
}
